import React from "react";
import { Button, Col, Dropdown, InputGroupProps, Modal, Row, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { XMLJSON, getDataReader } from "../../livedataFuncs";
import { DropdownArrayObj } from "../fileToolbarConsts";
import { createDateDayMonthYear, createDateToAMPMTimeNew, deleteNote, userInitials } from "../fileToolbarFuncs";
import { NoteRightSideReplies } from "./fileToolbarNoteReplies";
import { MainNoteItemTextBox, } from "./fileToolBarNoteTextArea";
import Form from 'react-bootstrap/Form';
import { RightMenuEditTextArea } from "./filetoolbarNoteEdit";
import { RightSideContext } from "../../Context/RightSideContext";
import { render } from "react-dom";
import { CustomToggle } from "../../Components/CustomToggle";
import { AddMenu } from "../../SideDrawer/addMenu";
import { Avatar } from "../../Components/ui/avatar/avatar";

interface IState {
    showReply: boolean,
    showReplyBox: boolean,
    deleteBox: boolean,
    showEditBox: boolean,
    showWholeMessage: boolean,
    isChecked?: boolean,
    isTextClipped: boolean,
}

interface IProps {
    node: XMLJSON,
    index: number,
    noteDropdownState: string,
    dataroot: any,
    setDeleteNoteState: (deleteNoteState: boolean) => void,
    showOpenNotesOnly: boolean,
}

export type AddNoteButton = {
    index: number,
    CreatedByUser: string,
    session: string;
    parentIndex?: number,
}

export interface AddNoteRepliesButton extends AddNoteButton {
    parentIndex: number;
}
// Sticky Note Items
export class MainNoteItems extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);

        this.state = {
            showReply: false,
            showReplyBox: false,
            deleteBox: false,
            showEditBox: false,
            showWholeMessage: false,
            isChecked: this.getCheckmarkValue() || false,
            isTextClipped: false,
        }
    }

    noteTextEl: HTMLDivElement | null = null;
    resizeObserver: ResizeObserver | null = null;

    setNoteTextRef = (el: HTMLDivElement | null) => {
        this.resizeObserver?.disconnect();
        this.noteTextEl = el;
        if (el) {
            if (!this.resizeObserver) {
                this.resizeObserver = new ResizeObserver(() => this.checkTextClipped());
            }
            this.resizeObserver.observe(el);
        }
    }

    /** The clamp is CSS-based (-webkit-line-clamp), so whether text is cut off depends on
     *  rendered width/font, not character count — measure the element instead of the string.
     *  Only measurable while clamped; when expanded, keep the last value so "Show less" stays visible. */
    checkTextClipped = () => {
        if (!this.noteTextEl || this.state.showWholeMessage) return;
        const isTextClipped = this.noteTextEl.scrollHeight > this.noteTextEl.clientHeight;
        if (isTextClipped !== this.state.isTextClipped) {
            this.setState({ isTextClipped });
        }
    }

    getCheckmarkValue = (): boolean => {
        const DataReaderObj = getDataReader(this.props.dataroot);
        const checkVal = DataReaderObj.getCheckmarkVal(this.props.index);
        return checkVal;
    }

    setShowReplyState = (changeState: boolean) => {
        this.setState({ showReply: changeState });
    }
    setShowReplyBoxState = (changeState: boolean) => {
        this.setState({ showReplyBox: changeState });
    }
    setDeleteBoxState = (changeState: boolean) => {
        this.setState({ deleteBox: changeState });
    }
    setEditBoxState = (changeState: boolean) => {
        this.setState({ showEditBox: changeState });
    }
    setWholeMessageState = (changeState: boolean) => {
        this.setState({ showWholeMessage: changeState });
    }
    toggleCheckmark = () => { 
        const DataReaderObj = getDataReader(this.props.dataroot);
        DataReaderObj.setNotesCheckmark(this.props.index);
        this.setState(prevState => ({ isChecked: !prevState.isChecked }));
    }

    componentWillUnmount() {
        this.resizeObserver?.disconnect();
        this.setState({
            showReply: false,
            showReplyBox: false,
            showEditBox: false,
        });
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.node !== this.props.node) {
            this.setState({
                showReplyBox: false,
                showEditBox: false,
                isChecked: this.getCheckmarkValue()
            });
        }
        this.checkTextClipped();
    }
    

    render() {
        let timeOfLastModified, daymonthyearModified, userInit = null;
        let dateToUse = this.props.node.attributes.LastModifiedDate?this.props.node.attributes.LastModifiedDate:this.props.node.attributes.CreateDate;
        if (dateToUse) {
            timeOfLastModified = createDateToAMPMTimeNew(dateToUse);
            daymonthyearModified = createDateDayMonthYear(dateToUse);
        }
        if (this.props.node.attributes.CreatedByUser) {
            if (this.props.node.attributes.DisplayName) {
                userInit = userInitials(this.props.node.attributes.DisplayName);
            } else {
                userInit = userInitials(this.props.node.attributes.CreatedByUser);
            }
        }
        let arrayPosition = DropdownArrayObj.mainScreenNameIndex[this.props.noteDropdownState];
        return (((this.props.node.attributes.mainScreenName === DropdownArrayObj.mainScreenNames[arrayPosition]) || arrayPosition === 8)
            && (this.props.showOpenNotesOnly ? !this.state.isChecked : true) &&
            <div className='note'>
                <div key={`note-${this.props.index}`}>
                    <div className="note-header">
                        <Row className="gx-0">
                            <Col md='auto'>
                                {userInit && <Avatar initials={userInit} />}
                            </Col>

                            <Col>
                                <Row className='gx-0'>
                                    <Col>
                                        <h3>
                                            {this.props.node.attributes.DisplayName ? this.props.node.attributes.DisplayName : this.props.node.attributes.CreatedByUser}
                                        </h3>
                                        <Form.Label>
                                            {daymonthyearModified} {timeOfLastModified}{this.props.node.attributes.Edited == '1' && ' (edited)'}
                                        </Form.Label>
                                    </Col>

                                    <Col md='auto' className='align-right'>
                                        <div className='hover-options' style={{display:'inline-block', marginRight:'5px'}}>
                                            <RightSideContext.Consumer>
                                                {value =>
                                                    <this.AddMenu
                                                        index={this.props.index}
                                                        CreatedByUser={this.props.node.attributes.CreatedByUser}
                                                        session={value.account} />
                                                }
                                            </RightSideContext.Consumer>
                                        </div>

                                        <OverlayTrigger placement="bottom" delay={200} overlay={
                                            <Tooltip>{this.state.isChecked ? `Mark as Unresolved` : `Mark as Resolved`}</Tooltip>
                                        }>
                                            <i onClick={this.toggleCheckmark} className={this.state.isChecked ? 'fa-solid fa-circle-check status-success' : 'fa-regular fa-circle-check'} style={{marginRight:'3px'}}></i>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    <div className="note-body">
                        {!this.state.showEditBox && (
                            <Badge pill bg="info" text="dark">
                                {DropdownArrayObj.mainScreenNameVals[this.props.node.attributes.mainScreenName]}
                            </Badge>
                        )}

                        <Row>
                            <Col>
                                {!this.state.showEditBox ?
                                    <div ref={this.setNoteTextRef} className={`note-container ${!this.state.showWholeMessage && 'note-container-hidden'}`}>
                                        <pre style={{margin: 0, background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 'inherit', padding: 0, whiteSpace: 'pre-wrap'}}>
                                            {this.props.node.attributes.text}
                                        </pre>
                                    </div>
                                    :
                                    <>
                                        <RightMenuEditTextArea
                                            text={this.props.node.attributes.text}
                                            setEditFlag={this.setEditBoxState}
                                            index={this.props.index}
                                            noteDropdownState={this.props.noteDropdownState}
                                            dataRoot={this.props.dataroot}
                                            category={this.props.node.attributes.mainScreenName}
                                        />
                                    </>
                                }
                            </Col>
                        </Row>

                        {(this.state.isTextClipped || this.state.showWholeMessage) &&
                            <Button variant="text" size="sm"
                                onClick={this.state.showWholeMessage ? () => { this.setWholeMessageState(false); } : () => { this.setWholeMessageState(true); }}>
                                Show {this.state.showWholeMessage ? 'less' : 'more'}
                            </Button>
                        }
                        
                        {this.state.showReply &&
                            this.props.node.children.map((object: XMLJSON, indexReply: number) =>
                                <NoteRightSideReplies key={`reply-div-${this.props.index}-${indexReply}`}
                                    index={indexReply}
                                    reply={object}
                                    parentIndex={this.props.index} />)
                        }

                        {this.state.showReplyBox &&
                            <MainNoteItemTextBox
                                index={this.props.index}
                                displayBoxHandler={this.setShowReplyBoxState}
                                showReplyBoxMessage={"Add reply here.."}
                                ReplyBoxType={"Reply"}
                                dataroot={this.props.dataroot}
                                noteDropdownState={this.props.noteDropdownState} />
                        }

                        <Row className="gx-0">
                            {(this.props.node.children.length > 0 || !this.state.showReplyBox) &&
                                <>
                                    <Col>
                                        {this.props.node.children.length > 0 &&
                                            <>
                                                <Button variant="text" size="sm" onClick={() => {
                                                    this.setShowReplyState(!this.state.showReply);
                                                }}>
                                                    {this.state.showReply ? 
                                                        <i className='fa-regular fa-caret-up'></i> 
                                                    : 
                                                        <i className='fa-regular fa-caret-down'></i>
                                                    }
                                                    
                                                    <i className="fa-regular fa-comments"></i>
                                                        Replies
                                                        ({this.props.node.children.length})
                                                </Button>
                                            </>
                                        }
                                    </Col>

                                    <Col className="align-right">
                                        <Button variant="text" size="sm" onClick={() => {
                                            this.setShowReplyState(true);
                                            this.setShowReplyBoxState(true);
                                        }}>
                                            <i className="fa-regular fa-reply"></i>
                                            Reply
                                        </Button>
                                    </Col>
                                </>
                            }
                        </Row>
                    </div>
                </div>
                
                <this.DeleteBox></this.DeleteBox>
            </div>
        )
    }
    /**
     * ... icon for dropdown
     */
    CustomToggle = React.forwardRef<HTMLInputElement, InputGroupProps>(
        ({ children, onClick }, ref) => (
            <i className={"fa-solid fa-ellipsis note-options"}
                ref={ref}
                onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
                }}>
                {children}
            </i>
        ))

    /**
     * Dropdown options for eclipse 
     */
    AddMenu = (props: AddNoteButton) => {
        return (
            <>
                {props.CreatedByUser === props.session &&
                    <Dropdown>
                        <Dropdown.Toggle as={this.CustomToggle} />
                        <Dropdown.Menu >
                            <Dropdown.Item key={`main-note-edit-${props.index}`}
                                onClick={() => {
                                    this.setEditBoxState(true);
                                }}>
                                Edit
                            </Dropdown.Item>

                            <Dropdown.Item key={`main-note-delete-${props.index}`}
                                onClick={() => {
                                    this.setDeleteBoxState(true);
                                }}>
                                Remove
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
            </>
        )
    }

    // Delete 
    DeleteBox = () => {
        return (
            <div key={`delete-box-${this.props.index}`}>
                {this.state.deleteBox &&
                    <Modal show={this.state.deleteBox} onHide={() => this.setDeleteBoxState(false)}>
                        <Modal.Header closeButton>
                            <h2>Remove Note</h2>
                        </Modal.Header>
                        <Modal.Body>You are about to remove this note. It will be permanently deleted when you save the file. Are you sure you want to continue?</Modal.Body>
                        <Modal.Footer>
                            <Button className="cancel-button" variant="outline-primary" onClick={() => this.setDeleteBoxState(false)}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={() => {
                                deleteNote(this.props.index);
                                this.props.setDeleteNoteState(true);
                                this.setDeleteBoxState(false)
                            }
                            }>
                                Remove
                            </Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>

        )
    }
}